// extracted by mini-css-extract-plugin
export var container = "_8t-1";
export var cornerButtonContainer = "_8t-5";
export var disabled = "_8t-2";
export var fileContainer = "_8t-4";
export var hiddenInput = "_8t-3";
export var widthContainer = "_8t-0";